<!-- Deprecated in favour of separate files for SMS and Whatsapp and also to implement new providers for each platform in the future-->
<template>
  <form class="row" @submit.prevent="createChannel()">
    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.channelName.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.LABEL') }}
        <input
          v-model.trim="channelName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.PLACEHOLDER')"
          @blur="$v.channelName.$touch"
        />
        <span v-if="$v.channelName.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.CHANNEL_NAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.LABEL') }}
        <input
          v-model.trim="phoneNumber"
          type="text"
          :disabled="!whatsappInbox"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.PLACEHOLDER')"
          @blur="$v.phoneNumber.$touch"
        />
        <span v-if="$v.phoneNumber.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.PHONE_NUMBER.ERROR')
        }}</span>
      </label>
    </div>

    <div v-if="whatsappInbox" class="small-12 medium-8 columns">
      <label :class="{ error: $v.accountSID.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.LABEL') }}
        <input
          v-model.trim="accountSID"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.PLACEHOLDER')"
          @blur="$v.accountSID.$touch"
        />
        <span v-if="$v.accountSID.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.ACCOUNT_SID.ERROR')
        }}</span>
      </label>
    </div>
    <div v-if="whatsappInbox" class="small-12 medium-8 columns">
      <label :class="{ error: $v.authToken.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.AUTH_TOKEN.LABEL') }}
        <input
          v-model.trim="authToken"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.AUTH_TOKEN.PLACEHOLDER')"
          @blur="$v.authToken.$touch"
        />
        <span v-if="$v.authToken.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.AUTH_TOKEN.ERROR')
        }}</span>
      </label>
    </div>

    <div v-if="type === 'call'" class="small-12 medium-8 columns">
      <label :class="{ error: $v.api_key_sid.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.APIKEY_SID.LABEL') }}
        <input
          v-model.trim="api_key_sid"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.APIKEY_SID.PLACEHOLDER')"
          @blur="$v.api_key_sid.$touch"
        />
        <span v-if="$v.api_key_sid.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.APIKEY_SID.ERROR')
        }}</span>
      </label>
    </div>
    <div v-if="type === 'call'" class="small-12 medium-8 columns">
      <label :class="{ error: $v.api_key_secret.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.APIKEY_SECRET.LABEL') }}
        <input
          v-model.trim="api_key_secret"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.APIKEY_SECRET.PLACEHOLDER')"
          @blur="$v.api_key_secret.$touch"
        />
        <span v-if="$v.api_key_secret.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.APIKEY_SECRET.ERROR')
        }}</span>
      </label>
    </div>
    <div v-if="type === 'call'" class="small-12 medium-8 columns">
      <label :class="{ error: $v.app_sid.$error }">
        {{ $t('INBOX_MGMT.ADD.TWILIO.APP_SID.LABEL') }}
        <input
          v-model.trim="app_sid"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.TWILIO.APP_SID.PLACEHOLDER')"
          @blur="$v.app_sid.$touch"
        />
        <span v-if="$v.app_sid.$error" class="message">{{
          $t('INBOX_MGMT.ADD.TWILIO.APP_SID.ERROR')
        }}</span>
      </label>
    </div>
    <div v-if="type === 'call'" class="small-12 medium-8 columns">
      <CheckboxInput
          v-model="record_audio"
          :label="$t('INBOX_MGMT.ADD.TWILIO.RECORD_AUDIO.LABEL')"
          @onToggle="onToggleRecord"
        />
    </div>


      <!-- :classNameWrapper="'form_builder_check'" -->


    <div class="small-12 medium-12 columns mt_20">
      <woot-submit-button
        :loading="uiFlags.isCreating"
        :button-text="$t('INBOX_MGMT.ADD.TWILIO.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required,requiredIf  } from 'vuelidate/lib/validators';
import router from '../../../../index';
import CheckboxInput from "components/ui/inputs/CheckboxInput.vue";


const shouldStartWithPlusSign = (value = '') => value.startsWith('+');

export default {
  components:{
    CheckboxInput,
  },
  mixins: [alertMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
    whatsappInbox: {
      type: Boolean,
      default: true,
    },
    communalInboxesDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      accountSID: this.accountSid(),
      authToken: this.fetchAuthToken(),
      medium: this.type,
      channelName: '',
      phoneNumber: this.fetchPhoneNumber(),

      api_key_sid:"",
      api_key_secret:"",
      app_sid:"",
      record_audio: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    phoneNumber: { required, shouldStartWithPlusSign },
    authToken: { required },
    accountSID: { required },
    medium: { required },
    api_key_sid: {
      required: requiredIf(function () {
        return this.type === 'call';
      })
    },
    api_key_secret: {
      required: requiredIf(function () {
        return this.type === 'call'; // ✅ required only if call
      })
    },
    app_sid: {
      required: requiredIf(function () {
        return this.type === 'call'; // ✅ required only if call
      })
    },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const callPayload = {
        api_key_sid: this.api_key_sid,
        api_key_secret: this.api_key_secret,
        app_sid: this.app_sid,
        record_audio: this.record_audio,
      }

      try {
        const twilioChannel = await this.$store.dispatch(
          'inboxes/createTwilioChannel',
          {
            twilio_channel: {
              name: this.channelName,
              medium: this.medium,
              account_sid: this.accountSID,
              auth_token: this.authToken,
              communal_type: this.whatsappInbox === false,
              phone_number: `+${this.phoneNumber.replace(/\D/g, '')}`,
              ...(this.type === 'call' ? callPayload : {}) // only when type is call
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: twilioChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.TWILIO.API.ERROR_MESSAGE'));
      }
    },
    accountSid() {
      return this.whatsappInbox
        ? ''
        : this.communalInboxesDetails.communal_whatsapp_twilio_sid;
    },
    fetchAuthToken() {
      return this.whatsappInbox
        ? ''
        : this.communalInboxesDetails.communal_whatsapp_twilio_token;
    },
    fetchPhoneNumber() {
      return this.whatsappInbox
        ? ''
        : this.communalInboxesDetails.communal_whatsapp_twilio_number;
    },
    onToggleRecord(){
      this.record_audio = !this.record_audio;
    },
  },
};
</script>
